import { DefaultImageType, ImageProperties } from '@/types/productServerApi';

export default function useProductAngleImage() {
    const getIsAngleImage = (properties: ImageProperties = { version: 0, type: DefaultImageType.Default }) => {
        return properties.type === DefaultImageType.Angle;
    };
    const getAngleImage = (sku: string) => {
        return `${sku}_angle`;
    };
    const getMaybeAngleImageSku = (sku: string, properties?: ImageProperties) => {
        const isAngleImage = getIsAngleImage(properties);
        return isAngleImage ? getAngleImage(sku) : sku;
    };
    return {
        getIsAngleImage,
        getAngleImage,
        getMaybeAngleImageSku,
    };
}
